import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=08ee19b0&scoped=true&lang=pug&"
import script from "./Training.vue?vue&type=script&lang=ts&"
export * from "./Training.vue?vue&type=script&lang=ts&"
import style0 from "./Training.vue?vue&type=style&index=0&id=08ee19b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee19b0",
  null
  
)

export default component.exports